<script>
    export let btnName = "カード名";
    export let btnImagePath = "";
    export let clickFunc = () => console.log("カードのコンポネントです。");
</script>

<article class="message" on:click={clickFunc}>
    <div class="message-header">
        <p>{btnName}</p>
    </div>
    <div class="message-body">
        <img src={btnImagePath} style="background-color:#FFFFFF;" alt="pict" />
    </div>
</article>
